import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const Trigger = ({ ariaLabel }) => (
  <button
    aria-label={ariaLabel}
    className='vst-btn--transparent styled-as-link u-hard u-weight--medium'
  >
    <FormattedMessage id='common.edit' />
  </button>
)

export default Trigger

Trigger.propTypes = { ariaLabel: PropTypes.string }
